// extracted by mini-css-extract-plugin
module.exports = {"cardLogoWrapper":"logo_cardLogoWrapper__1QzbR","cardLogo":"logo_cardLogo__1WeRe"};